var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.13193C12.0001 6.10825 12.0001 6.65562 12.0001 7.63193M12.0001 10.1319L12.0063 10.1319M22 20.125H18.25V22.625L13.875 18.25L18.25 13.875V16.375H22V20.125ZM2.00003 16.375H5.75003V13.875L10.125 18.25L5.75003 22.625V20.125H2.00003V16.375ZM13.7236 12.9794C14.9998 12.5686 16.0873 11.7155 16.7901 10.5739C17.4929 9.43224 17.7649 8.07709 17.557 6.75266C17.3491 5.42823 16.675 4.2216 15.6561 3.35022C14.6373 2.47883 13.3407 2 12 2C10.6594 2 9.36282 2.47883 8.34397 3.35022C7.32513 4.2216 6.65101 5.42823 6.4431 6.75266C6.23519 8.07709 6.50715 9.43224 7.20999 10.5739C7.91282 11.7155 9.0003 12.5686 10.2765 12.9794L12 16.4708L13.7236 12.9794Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectionsIcon);
export default __webpack_public_path__ + "static/media/objections-icon.a594d84a5b6c63c47a62674814c7a18b.svg";
export { ForwardRef as ReactComponent };